import { config } from "../utils/config";
import { omniAxios } from "../utils/axios";
import { CookieKeys, Cookies } from "../utils/cookieKey";
//发送验证码
export function apiUserRegisterMobileCode({ shouji, tips }) {
  //200-验证码发送成功，100004-访问太多受到限制，100003-验证码已发送，请超过60秒后重试,
  //100005-短信发送失败，请重试，100006-访问频繁需要通过滑动验证码验证，100007-手机号已注册
  return omniAxios({
    url: config.apiUserRegisterMobileCodePath,
    method: "post",
    params: { shouji, tips },
    isFormData: true,
    header: {
      nowUrl: window.location.href,
    },
  });
}
//校验验证码
export function apiUserRegisterCodeValidate({ phone, code }) {
  return omniAxios({
    url: config.apiUserRegisterCodeValidatePath,
    method: "get",
    params: { phone, code },
  });
}
//提交注册
export function apiUserRegisterTemregist({ company, name, phone, code, zhiwu, source }) {
  return omniAxios({
    url: config.apiUserRegisterTemregistPath,
    method: "post",
    params: {
      company,
      name,
      phone,
      code,
      zhiwu,
      source,
      fingerId: Cookies.get(CookieKeys.qlmVisitorId),
      regUrl: window.location.href,
      regTitle: document.title,
    },
    isFormData: true,
    header: {
      refererUrl: window.location.href,
    },
  });
}
//完成注册
export function apiUserRegisterTemregistUpdate({ company, name, phone, code, zhiwu, source }) {
  return omniAxios({
    url: config.apiUserRegisterTemregistUpdatePath,
    method: "post",
    params: {
      company,
      name,
      phone,
      code,
      zhiwu,
      source,
      fingerId: Cookies.get(CookieKeys.qlmVisitorId),
      regUrl: window.location.href,
      regTitle: document.title,
    },
    isFormData: true,
    header: {
      refererUrl: window.location.href,
    },
  });
}
//验证码埋点
export function buryPointRegisterMonitorAddRegisterCodePoint({ phone }) {
  return omniAxios({
    url: config.buryPointRegisterMonitorAddRegisterCodePointPath,
    method: "post",
    params: { phone, type: 1 },
    isFormData: true,
  });
}
//注册成功埋点
export function buryPointRegisterMonitorUpdateRegisterCodePoint({ phone }) {
  return omniAxios({
    url: config.buryPointRegisterMonitorUpdateRegisterCodePointPath,
    method: "post",
    params: {
      phone,
      type: 1,
      fingerId: Cookies.get(CookieKeys.qlmVisitorId),
      regUrl: window.location.href,
      regTitle: document.title,
    },
    isFormData: true,
  });
}

export function restHomepageLoginConfig() {
  return omniAxios({
    url: config.restHomepageLoginConfigPath,
    method: "get",
  });
}

//restBuryPointUserBehaviorInsertRegistTypel
export function restBuryPointUserBehaviorInsertRegistType(params) {
  return omniAxios({
    url: config.restBuryPointUserBehaviorInsertRegistTypePath,
    method: "post",
    params:{
      ...params,
      fingerId: Cookies.get(CookieKeys.qlmVisitorId),
    },
    withCredentials: false,
  });
}